<template>
    <div class="statistics-container">
        <el-row :gutter="20" class="chart-section">
            <el-col :span="12">
                <!-- 状态统计卡片 -->
                <div class="stats-section">
                    <el-card class="chart-card" shadow="hover">
                        <div slot="header" class="card-header">
                            <!-- <i class="el-icon-data-analysis"></i> -->
                            <span>文件状态统计</span>
                        </div>
                        <el-row :gutter="20" class="stats-row">
                            <el-col :span="6" v-for="(item, index) in statusCards" :key="item.key"
                                :style="{ animationDelay: `${index * 0.1}s` }" class="stat-col">
                                <div class="stat-card" :class="item.class">
                                    <!-- <div class="stat-icon">
                                    <i :class="item.icon" style="font-size: 20px;"></i>
                                </div> -->
                                    <div class="stat-content">

                                        <div class="stat-label"> <i :class="item.icon" class="stat-icon"
                                                style="font-size: 15px;"></i>{{
                                                    item.label }}</div>
                                        <div class="stat-value">{{ bystatus[item.key] || 0 }}</div>
                                    </div>
                                    <div class="stat-decoration"></div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="12">
                <!-- 更新统计卡片 -->
                <div class="stats-section">
                    <el-card class="chart-card" shadow="hover">
                        <div slot="header" class="card-header">
                            <!-- <i class="el-icon-refresh"></i> -->
                            <span>文件更新统计</span>
                        </div>
                        <el-row :gutter="20" class="stats-row">
                            <el-col :span="6" v-for="(item, index) in updateCards" :key="item.key"
                                :style="{ animationDelay: `${(index + 4) * 0.1}s` }" class="stat-col">
                                <div class="stat-card update-card">
                                    <!-- <div class="stat-icon">
                                        <i :class="item.icon" style="font-size: 20px;"></i>
                                    </div> -->
                                    <div class="stat-content">

                                        <div class="stat-label"> <i :class="item.icon" class="stat-icon"
                                                style="font-size: 15px;"></i>{{ item.label }}</div>
                                        <div class="stat-value">{{ updateStatus[item.key] || 0 }}</div>
                                    </div>
                                    <div class="stat-decoration"></div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </el-col>
        </el-row>


        <!-- 图表和表格区域 -->
        <el-row :gutter="20" class="chart-section">
            <el-col :span="12">
                <el-card class="chart-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <!-- <i class="el-icon-pie-chart"></i> -->
                        <span>文件类型分布</span>
                    </div>
                    <my_chart class="chart-content" :option="option"></my_chart>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="table-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <!-- <i class="el-icon-office-building"></i> -->
                        <span>部门文件统计</span>
                    </div>
                    <el-table :data="bydept" class="dept-table">
                        <el-table-column prop="deptName" label="部门名称" align="center">

                        </el-table-column>
                        <el-table-column prop="fileCount" label="文件数量" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.fileCount }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as c from '@/utils/config'
import * as u from '@/utils/util'
import { mapActions } from 'vuex'

export default {
    name: "sy",
    components: {
        'my_chart': () => import('@/components/myChart/index.vue'),
    },
    data() {
        return {
            //用户信息
            userInfo: u.getSession(c.sessionKey.USER_INFO),
            //系统信息
            sysInfo: [
                { label: '系统版本', value: "2.0v" },
                { label: '操作系统', value: "windows" },
                { label: '数据库', value: "mysql5.7" },
                { label: '运行环境', value: "jdk8/maven/nodeV16.14.1/redis" },
            ],
            fileTypeList: [],
            bystatus: {},
            updateStatus: {},
            bydept: [],
            option: {},
            statusCards: [
                { key: 'draftCount', label: '草稿数', icon: 'el-icon-edit-outline', class: 'draft-card' },
                { key: 'pendingCount', label: '待审核数', icon: 'el-icon-time', class: 'pending-card' },
                { key: 'effectiveCount', label: '审核通过数', icon: 'el-icon-circle-check', class: 'effective-card' },
                { key: 'abolishedCount', label: '废除数', icon: 'el-icon-circle-close', class: 'abolished-card' }
            ],
            updateCards: [
                { key: 'todayCount', label: '今日更新', icon: 'el-icon-sunny' },
                { key: 'weekCount', label: '本周更新', icon: 'el-icon-date' },
                { key: 'monthCount', label: '本月更新', icon: 'el-icon-s-grid' },
                { key: 'totalCount', label: '总共更新', icon: 'el-icon-data-line' }
            ]
        }
    },
    mounted() {
        this.getFolderStatistics();
    },
    methods: {
        getFolderStatistics() {
            // 根据文件状态统计
            this.$HttpService.get(`/file-info/count/by-status`).then(res => {
                this.bystatus = res || {};
            }).catch(() => {
                this.$message.error('加载文件夹统计失败');
            })
            // 根据文件类型统计
            this.$HttpService.get(`/file-info/count/by-type`).then(res => {
                this.fileTypeList = res || [];
                this.updateChartOption();
            }).catch(() => {
                this.$message.error('加载文件夹统计失败');
            }) // 根据部门统计
            this.$HttpService.get(`/permission/by-dept`).then(res => {
                this.bydept = [res] || [];
            }).catch(() => {
                this.$message.error('加载部门统计失败');
            }) // 根据文件状态统计
            this.$HttpService.get(`/file-stats/update-stats`).then(res => {
                this.updateStatus = res || {};
            }).catch(() => {
                this.$message.error('加载文件夹统计失败');
            })
        },
        updateChartOption() {
            const colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4'];

            this.option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} 个 ({d}%)',
                    backgroundColor: 'rgba(50, 50, 50, 0.9)',
                    borderColor: '#333',
                    borderWidth: 1,
                    textStyle: {
                        color: '#fff'
                    }
                },
                legend: {
                    orient: 'vertical',
                    right: '5%',
                    top: 'center',
                    itemWidth: 14,
                    itemHeight: 14,
                    textStyle: {
                        fontSize: 13,
                        color: '#666'
                    }
                },
                color: colors,
                series: [
                    {
                        name: '文件类型',
                        type: 'pie',
                        radius: ['45%', '70%'],
                        center: ['40%', '50%'],
                        avoidLabelOverlap: true,
                        itemStyle: {
                            borderRadius: 8,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: true,
                            formatter: '{b}\n{d}%',
                            fontSize: 12,
                            color: '#666'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            },
                            itemStyle: {
                                shadowBlur: 20,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.3)'
                            }
                        },
                        data: this.fileTypeList.map(item => ({
                            name: item.fileType,
                            value: item.count
                        }))
                    }
                ]
            };
        }
    },
}
</script>

<style scoped lang="scss">
.statistics-container {
    padding: 16px;
    background: #f5f6f7;
    min-height: 100vh;

    .stats-section {
        margin-bottom: 24px;

        .section-title {
            color: #333;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            gap: 8px;

            i {
                font-size: 24px;
                color: #409eff;
            }
        }
    }

    .stats-row {
        background-color: #fff;
        border-radius: 20px;
        margin: 10px;

        .stat-col {
            animation: slideInUp 0.6s ease-out backwards;
        }
    }

    .stat-card {
        // background: #fff;
        border-radius: 16px;
        padding: 12px 5px;
        position: relative;
        overflow: hidden;
        transition: all 0.3s ease;
        // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        display: flex;
        align-items: center;
        gap: 10px;

        // &:hover {
        //     transform: translateY(-8px);
        //     box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);

        //     .stat-icon {
        //         transform: scale(1.1) rotate(5deg);
        //     }
        // }

        .stat-icon {
            // width: 40px;
            // height: 40px;
            // border-radius: 12px;
            // display: flex;
            // align-items: center;
            // justify-content: center;
            // font-size: 28px;
            // transition: all 0.3s ease;
            // flex-shrink: 0;
        }

        .stat-content {
            flex: 1;
            text-align: center;

            .stat-label {
                font-size: 14px;
                color: #666;
                margin-bottom: 8px;
                font-weight: 500;
            }

            .stat-value {
                font-size: 30px;
                font-weight: 700;
                line-height: 1;

            }
        }

        // .stat-decoration {
        //     position: absolute;
        //     right: -20px;
        //     bottom: -20px;
        //     width: 100px;
        //     height: 100px;
        //     border-radius: 50%;
        //     opacity: 0.1;
        // }

        &.draft-card {
            .stat-icon {
                // background: linear-gradient(135deg, #ffa726 0%, #fb8c00 100%);
                color: #ffa726;
            }

            .stat-value {
                color: #fb8c00;
            }

            .stat-decoration {
                background: #ffa726;
            }
        }

        &.pending-card {
            .stat-icon {
                // background: linear-gradient(135deg, #42a5f5 0%, #1e88e5 100%);
                color: #42a5f5;
            }

            .stat-value {
                color: #1e88e5;
            }

            .stat-decoration {
                background: #42a5f5;
            }
        }

        &.effective-card {
            .stat-icon {
                // background: linear-gradient(135deg, #66bb6a 0%, #43a047 100%);
                color: #66bb6a;
            }

            .stat-value {
                color: #43a047;
            }

            .stat-decoration {
                background: #66bb6a;
            }
        }

        &.abolished-card {
            .stat-icon {
                // background: linear-gradient(135deg, #ef5350 0%, #e53935 100%);
                color: #ef5350;
            }

            .stat-value {
                color: #e53935;
            }

            .stat-decoration {
                background: #ef5350;
            }
        }

        &.update-card {
            .stat-icon {
                // background: linear-gradient(135deg, #ab47bc 0%, #8e24aa 100%);
                color: #ab47bc;
            }

            .stat-value {
                color: #8e24aa;
            }

            .stat-decoration {
                background: #ab47bc;
            }
        }
    }

    .card-header {
        color: #333;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;

        i {
            font-size: 20px;
            color: #409eff;
        }
    }

    .chart-section {
        animation: fadeIn 0.8s ease-out 0.4s backwards;

        .chart-card,
        .table-card {
            border-radius: 16px;
            overflow: hidden;

            ::v-deep .el-card__header {
                background: #fff;
                border-bottom: 2px solid #e8eaed;
                padding: 12px 15px;


            }

            ::v-deep .el-card__body {
                padding: 0 12px;
            }
        }

        .chart-content {
            height: calc(100vh - 370px);
        }

        .dept-table {
            height: calc(100vh - 370px);
            ::v-deep .el-table__header {
                th {
                    background: #f8f9fa;
                    color: #333;
                    font-weight: 600;
                }
            }

            ::v-deep .el-table__row {
                transition: all 0.3s ease;

                // &:hover {
                //     background: #f0f7ff !important;
                // }
            }

            .dept-name {
                display: flex;
                align-items: center;
                gap: 8px;

                i {
                    color: #667eea;
                    font-size: 16px;
                }
            }

            .count-tag {
                font-size: 14px;
                font-weight: 600;
                padding: 8px 16px;
                border-radius: 20px;
            }
        }
    }
}

@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>